import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import classnames from "classnames";
import OtpInput from "react-otp-input";
import Countdown from "react-countdown";
import Button from "@componentsShared/buts/SubmitButton/SubmitButton";
import stl from "./Otp.module.css";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import OtpIcon from "@/_MiniApps/auth/ui/OTP/OtpIcon";
var VerifyOtp = function VerifyOtp(_ref) {
  var phoneNumber = _ref.phoneNumber,
    value = _ref.value,
    error = _ref.error,
    loading = _ref.loading,
    subClassName = _ref.subClassName,
    className = _ref.className,
    title = _ref.title,
    label = _ref.label,
    btnText = _ref.btnText,
    otpBtn = _ref.otpBtn,
    length = _ref.length,
    onEdit = _ref.onEdit,
    onChange = _ref.onChange,
    onResend = _ref.onResend,
    isOtpSent = _ref.isOtpSent,
    setIsOtpSent = _ref.setIsOtpSent,
    editNumberClass = _ref.editNumberClass,
    onValidate = _ref.onValidate,
    _ref$useForSema = _ref.useForSema,
    useForSema = _ref$useForSema === void 0 ? false : _ref$useForSema,
    countDownfromArib = _ref.countDownfromArib,
    _ref$disabledResend = _ref.disabledResend,
    disabledResend = _ref$disabledResend === void 0 ? false : _ref$disabledResend,
    _ref$withborder = _ref.withborder,
    withborder = _ref$withborder === void 0 ? true : _ref$withborder;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useState = useState(false),
    showResend = _useState[0],
    setShowResend = _useState[1];
  var _useState2 = useState(true),
    showCountDown = _useState2[0],
    setShowCountDown = _useState2[1];
  var _useState3 = useState(false),
    showOtpSentMessage = _useState3[0],
    setShowOtpSentMessage = _useState3[1];
  var _useState4 = useState(false),
    isAutoTriggerd = _useState4[0],
    setIsAutoTriggerd = _useState4[1];
  useEffect(function () {
    if (!showOtpSentMessage) return;
    setTimeout(function () {
      setShowOtpSentMessage(false);
      setShowCountDown(true);
    }, 1000);
  }, [showOtpSentMessage]);
  useEffect(function () {
    isAutoTriggerd && setIsAutoTriggerd(false);
  }, [isAutoTriggerd]);
  useEffect(function () {
    if (!isOtpSent) return;
    setShowOtpSentMessage(true);
    setShowResend(false);
  }, [isOtpSent]);
  return /*#__PURE__*/React.createElement("div", {
    className: !useForSema ? [stl.wrapper, error && stl.hasError, className, withborder && stl.wrapperWithBorder].filter(Boolean).join(" ") : ""
  }, !useForSema && /*#__PURE__*/React.createElement(OtpIcon, {
    className: "mb-6 w-24 h-20"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#154f9c] text-center text-lg font-bold mt-4 mb-3"
  }, !useForSema && title ? t(title, {
    ns: "web_common"
  }) : tShort("verify_phone_number", {
    ns: "otp_screen"
  })), !useForSema && /*#__PURE__*/React.createElement("label", {
    className: "text-center text-sm not-italic font-semibold my-3"
  }, label), !useForSema && /*#__PURE__*/React.createElement("strong", {
    className: [stl.number, subClassName ? subClassName : ""].join(" ") + " mt-3"
  }, phoneNumber), !useForSema && /*#__PURE__*/React.createElement(Button, {
    id: "login-edit-phone-btn",
    type: "button",
    className: "".concat(stl.edit, " ").concat(editNumberClass ? editNumberClass : ""),
    onClick: onEdit
  }, tShort("edit_mobile_number", {
    "ns": "otp_screen"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.input_Err_Container
  }, /*#__PURE__*/React.createElement(OtpInput, {
    inputStyle: stl.optInput,
    shouldAutoFocus: true,
    inputType: "number",
    containerStyle: stl.OtpWrapper
    // hasErrored={length === value.length && error}
    ,
    numInputs: length ? length : 4,
    onChange: onChange,
    renderSeparator: /*#__PURE__*/React.createElement(React.Fragment, null),
    value: value,
    placeholder: new Array(length ? length : 4).fill("0").join(""),
    renderInput: function renderInput(props, index) {
      return /*#__PURE__*/React.createElement("input", _extends({}, props, {
        id: index === 0 ? "login-otp-input" : undefined,
        type: "tel",
        className: classnames(_defineProperty(_defineProperty({}, stl.optInput, true), stl.otpError, length === (value === null || value === void 0 ? void 0 : value.length) ? error : undefined))
      }));
    }
  }), error && /*#__PURE__*/React.createElement("span", {
    id: "login-otp-error",
    className: stl.error
  }, error)), disabledResend && /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-6 text-[#6c7a8d] mt-4 mb-10 text-center"
  }, t("wait_trying_resend_code", {
    ns: "web_common"
  }), "."), showResend && !disabledResend && /*#__PURE__*/React.createElement("p", {
    className: "flex text-sm leading-6 text-[#6c7a8d] mt-4 mb-10 justify-center"
  }, t("didn_t_receive_code", {
    ns: "web_common"
  }), ".", /*#__PURE__*/React.createElement(Button, {
    id: "login-resend-otp-btn",
    type: "button",
    onClick: function onClick() {
      onResend();
      countDownfromArib && setShowResend(false);
      countDownfromArib && setShowCountDown(true);
    },
    className: countDownfromArib ? "!inline !w-auto !h-auto !bg-transparent !text-[#154f9c] !text-[14px]" : undefined
  }, t("resend", {
    ns: "web_common"
  }))), showOtpSentMessage && /*#__PURE__*/React.createElement("p", {
    id: "login-otp-success",
    className: stl.green
  }, t("verification_code_resent", {
    ns: "web_common"
  })), showCountDown && !disabledResend && /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-6 text-[#6c7a8d] flex my-4 mb-10"
  }, tShort("resend_code_in", {
    "ns": "otp_screen"
  }), /*#__PURE__*/React.createElement("span", {
    className: "mx-1 text-[#154f9c]"
  }, /*#__PURE__*/React.createElement(Countdown, {
    date: countDownfromArib !== null && countDownfromArib !== void 0 ? countDownfromArib : Date.now() + 59 * 1000,
    renderer: function renderer(_ref2) {
      var minutes = _ref2.minutes,
        seconds = _ref2.seconds,
        completed = _ref2.completed;
      if (completed) {
        return /*#__PURE__*/React.createElement("strong", null, "0");
      }
      var totalSeconds = minutes * 60 + seconds;
      return /*#__PURE__*/React.createElement("strong", null, totalSeconds);
    },
    onComplete: function onComplete() {
      setShowCountDown(false);
      setShowResend(true);
      setIsOtpSent(false);
    }
  })), " ", t("seconds", {
    ns: "web_common"
  })), !useForSema && /*#__PURE__*/React.createElement(SubmitButton, {
    id: "login-submit-btn",
    onClick: onValidate,
    type: "button",
    disabled: loading,
    loading: loading,
    className: [otpBtn ? otpBtn : "", length !== (value === null || value === void 0 ? void 0 : value.length) ? stl.notActive : undefined].join(" ")
  }, btnText));
};
export default VerifyOtp;